import goldCoinUrl from '/web/icons/gold-coin.svg'

interface TokenCoinProps {
  size?: number
  class?: string
  style?: Record<string, string>
}

export function TokenCoin(props: TokenCoinProps) {
  const size = () => props.size ?? 18
  return (
    <img
      src={goldCoinUrl}
      alt="tokens"
      class={props.class}
      style={{
        width: `${size()}px`,
        height: `${size()}px`,
        display: 'inline-block',
        'vertical-align': 'middle',
        'flex-shrink': '0',
        ...props.style,
      }}
    />
  )
}
